
// 定义事件数据的类型
// import EventTrack from "@/Core/EventTrack";

import {KitEvent} from "@/Fwk/Kit/Track/KitEvent";

interface EventData {
    [key: string]: any;
}

// SdkTrack 类用于处理和提交跟踪事件
export default class SdkTrack {

    static track513Commit(name: string, value1?: string, value2?: string, keyValues?:Map<string, string>) {
        const kitEvent = KitEvent.track513(name);
        if (value1) kitEvent.Put1(value1);
        if (value2) kitEvent.Put2(value2);
        if (keyValues) kitEvent.PutMap(keyValues);
        kitEvent.Commit();
    }


    static track512Commit(name: string, value1?: string, value2?: string, keyValues?:Map<string, string>) {
        const kitEvent = KitEvent.track512(name);
        if (value1) kitEvent.Put1(value1);
        if (value2) kitEvent.Put2(value2);
        if (keyValues) kitEvent.PutMap(keyValues);
        kitEvent.Commit();
    }

}
